import React, { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Integrations from "./components/Integrations";
import AccountSettings from "./components/AccountSettings";
import AccessLogin from "./components/AccessLogin";
import { useUserContext } from "@/context/UserContext";
import OrdersSettings from "./components/OrdersSettings";
import { Settings as SettingsInterface } from "@/interface/entityInterface";
import { getSettings } from "@/api/settings";

const Settings: React.FC = () => {
  const { decodedToken } = useUserContext();
  const [settings, setSettings] = useState<SettingsInterface | null>(null);

  useEffect(() => {
    if (!decodedToken) return;
    const getCompanySettings = async () => {
      const data = await getSettings(decodedToken.settings.id);
      const {
        id,
        company_logo,
        name,
        currency,
        settings_type,
        api_key,
        show_driver_on_order_assign,
        show_phone_number_to_driver,
        show_vehicle_on_order_assign,
        completed_orders
      } = data;

      setSettings({
        id,
        company_logo,
        name,
        settings_type,
        currency,
        api_key,
        show_driver_on_order_assign,
        show_phone_number_to_driver,
        show_vehicle_on_order_assign,
        completed_orders
      });
    };

    getCompanySettings();
  }, [decodedToken]);

  return (
    <div>
      <div className="p-8">
        <Tabs defaultValue="setings">
          <TabsList>
            <TabsTrigger value="setings">Settings</TabsTrigger>
            {decodedToken && decodedToken.permissions.user_role == "owner" && (
              <TabsTrigger value="orders">Orders</TabsTrigger>
            )}
            <TabsTrigger value="security">Access & Login</TabsTrigger>
            {decodedToken && decodedToken.permissions.user_role == "owner" && (
              <TabsTrigger value="integrations">Integrations</TabsTrigger>
            )}
          </TabsList>
          <TabsContent value="setings">
            <AccountSettings settings={settings} />
          </TabsContent>
          {decodedToken && decodedToken.permissions.user_role == "owner" && (
            <TabsContent value="orders">
              <OrdersSettings settings={settings} />
            </TabsContent>
          )}
          <TabsContent value="security">
            <AccessLogin />
          </TabsContent>
          {decodedToken && decodedToken.permissions.user_role == "owner" && (
            <TabsContent value="integrations">
              <Integrations />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default Settings;
